const { instance } = require('./url')

async function getAllScheduleMaterialTemplates() {
    return await instance.get('/schedule_material_template/all')
}

async function insertScheduleMaterialTemplate(t) {
    return await instance.post('/schedule_material_template/', { template: t })
}

async function updateScheduleMaterialTemplate(t) {
    return await instance.put('/schedule_material_template/' + t.id, { template: t })
}

async function deleteScheduleMaterialTemplate(id) {
    return await instance.delete('/schedule_material_template/' + id)
}

module.exports = {
    getAllScheduleMaterialTemplates,
    insertScheduleMaterialTemplate,
    updateScheduleMaterialTemplate,
    deleteScheduleMaterialTemplate,
}
